import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { set } from "lodash";
import { ListNetworkData } from "../../utils/list/objects/listNetworkData";
import { ListPeriodFilterShortcut } from "../../utils/list/objects/listPeriodFilterShortcut";
import { EditNewsletterContact } from "../objects/editNewsletterContact";
import { NewsletterContactInput } from "../objects/newsletterContactInput";
import { NewsletterContactsState } from "../objects/newsletterContactsState";

const initialState: NewsletterContactsState = {
    createContactsForm: [
        {
            email: '',
            lastName: '',
            firstName: ''
        }
    ],
    editContact: {state: 'loading'},
    editContactForm: {
        email: '',
        lastName: '',
        firstName: ''
    },
    listData: {
        state: 'loading'
    },
    listFilters: {
        period: {
            type: 'CREATION',
            shortcut: ListPeriodFilterShortcut.CUSTOM,
            values: {
                CREATION: {
                    LESS_THAN: new Date().toISOString(),
                    GREATER_THAN: new Date().toISOString(),
                },
                MODIFICATION: {
                    LESS_THAN: new Date().toISOString(),
                    GREATER_THAN: new Date().toISOString(),
                },
            }
        },
        creator: '',
        last_author: '',
    },
    listOrder: {
        type: 'asc',
        by: ''
    },
    listPagination: {
        limit: 24,
        page: 0
    },
};

const slice = createSlice({
    name: 'newsletterContacts',
    initialState: initialState,
    reducers: {
        addCreateContactsItem: (
            state,
        ): void => {
            state.createContactsForm.push({
                email: '',
                lastName: '',
                firstName: ''
            });
        },
        deleteCreateContactsItem: (
            state,
            action: PayloadAction<{
                index: number
            }>
        ): void => {
            state.createContactsForm = state.createContactsForm.filter((_, index) => {
                return index !== action.payload.index;
            });
        },
        setCreateContactsForm: (
            state,
            action: PayloadAction<{
                inputs: NewsletterContactInput[]
            }>
        ): void => {
            state.createContactsForm = action.payload.inputs;
        },
        setCreateContactsFormValue: (
            state,
            action: PayloadAction<{
                index: number,
                key: keyof NewsletterContactInput,
                value: NewsletterContactInput[keyof NewsletterContactInput]
            }>
        ): void => {
            const contact = state.createContactsForm[action.payload.index];

            if (contact) {
                contact[action.payload.key] = action.payload.value;
            }
        },
        setListData: (
            state,
            action: PayloadAction<ListNetworkData>
        ): void => {
            state.listData = action.payload;
        },
        setListFiltersValue: (
            state,
            action: PayloadAction<{
                key: string,
                value: any
            }>
        ): void => {
            set(state.listFilters, action.payload.key, action.payload.value);
        },
        setEditContact: (
            state,
            action: PayloadAction<EditNewsletterContact>
        ): void => {
            state.editContact = action.payload;
        },
        setEditContactForm: (
            state,
            action: PayloadAction<NewsletterContactInput>
        ): void => {
            state.editContactForm = action.payload;
        },
        setEditContactFormValue: (
            state,
            action: PayloadAction<{
                key: keyof NewsletterContactInput,
                value: NewsletterContactInput[keyof NewsletterContactInput]
            }>
        ): void => {
            state.editContactForm[action.payload.key] = action.payload.value;
        }
    }
});

export const {
    addCreateContactsItem,
    deleteCreateContactsItem,
    setCreateContactsForm,
    setCreateContactsFormValue,
    setListData,
    setListFiltersValue,
    setEditContact,
    setEditContactForm,
    setEditContactFormValue
} = slice.actions;

export default slice;